<div class="apiz-p-grid">
  <ng-template iuDynamicContainer></ng-template>
</div>
